import { render, staticRenderFns } from "./CourseDetail.vue?vue&type=template&id=2b31e81c&scoped=true&"
import script from "./CourseDetail.vue?vue&type=script&lang=ts&"
export * from "./CourseDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CourseDetail.vue?vue&type=style&index=0&id=2b31e81c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b31e81c",
  null
  
)

export default component.exports